import { BranchCategoryUpdatePage } from '@/features/branch-category/pages/BranchCategoryUpdate'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/branch-category/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["branch_category.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: BranchCategoryUpdatePage,
})
